<template>
    <div class="fault-chart" id="deliveryFaultBarChart"></div>
</template>

<script>
    import echarts from 'echarts'
    import deliveryFaultBar from './deliveryFaultBar.js'
    export default {
        name: '',
        components: {},
        mounted: function () {
            this.init()
        },
        data: function () {
            return {
                myChart: null,
                deliveryFaultBar: deliveryFaultBar,
            }
        },
        methods: {
            init(){
                this.myChart = echarts.init(document.getElementById('deliveryFaultBarChart'));
                this.myChart.setOption(this.deliveryFaultBar)
            }
        },
    }
</script>

<style lang="scss">
    .fault-chart{
        height: 100%;
    }
</style>
